/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    import IPagedResultsColumns = Meevo.Components.BaseClasses.IPagedResultsColumns;

    export class LocationsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.DataMaintenance> {
        public infiniteList: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public scrollColumnsObj: IPagedResultsColumns = {
            scrollColumns: 2,
            desktop: window.matchMedia("(min-width: 960px)"),
            tablet: window.matchMedia("(min-width: 600px) and (max-width: 959px)"),
            mobile: window.matchMedia("(max-width: 599px)"),
            checkScrollColumns: function () {
                if (this.desktop.matches || this.tablet.matches) {
                    this.scrollColumns = 2;
                } else if (this.mobile.matches) {
                    this.scrollColumns = 1;
                }
            },
        };
        public location: any;

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

            this.infiniteList = new Meevo.Components.BaseClasses.PagedResults(this.params.dataService,  "location", null, null, this.scrollColumnsObj, null, true);
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {}

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            this.filterLocation();
        }

        public filterLocation(): void {
            let request = {
                pageNumber: 0,
                itemsPerPage: 24,
                criteria: {
                    filterBySessionUser: true,
                    includeActive: true,
                    priceGroupId: this.parentItemId,
                    locationGroupId: this.location ? this.location.id : ""
                },
                sortBy: '',
                sortDirection: Model.SortDirection.Ascending
            };
            this.infiniteList.initSearch(request);
        }

    }
}